import { Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import type { Board } from '../../types';

interface JoinCTAProps {
  board: Board;
}

export const JoinCTA: React.FC<JoinCTAProps> = ({ board }) => {
  const navigate = useNavigate();
  const isLocked = board.status === 'locked';
  const isCompleted = board.status === 'completed';
  const canJoin = !isLocked && !isCompleted;
  const boardPath = board.slug || board.id;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'sticky',
        bottom: 0,
        py: 2,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        borderRadius: 0,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        zIndex: 10,
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 500 }}
      >
        {canJoin ? 'Want to play?' : 'This board has ended.'}
      </Typography>
      <Button
        variant="contained"
        size="medium"
        onClick={() => {
          if (canJoin) {
            navigate(`/boards/${boardPath}/invite/${board.inviteCode}`);
          } else {
            navigate(`/b/${boardPath}`);
          }
        }}
        sx={{
          fontWeight: 700,
          px: 3,
          ...(canJoin
            ? {
                background:
                  'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                color: '#000',
                '&:hover': {
                  background:
                    'linear-gradient(135deg, #FFE44D 0%, #FFB733 100%)',
                },
              }
            : {}),
        }}
      >
        {canJoin ? 'Join This Board' : 'View Board'}
      </Button>
    </Paper>
  );
};
